import { useEffect, useState } from 'react';
import { isOnline } from '../lib/platform.ts';

/**
 * Phase 10 — حالة «لا يوجد اتصال».
 *
 * واجهة التطبيق مُضمَّنة داخل الـAPK، فتظهر الشاشات بلا إنترنت بينما لا تعمل أي عملية:
 * كل حجز ودفعة وحضور وتسوية على الخادم. بلا هذا الشريط يبدو التطبيق سليمًا ويفشل صامتًا.
 *
 * وهو إخبار فقط (قرار المالك D-9): لا حجز بلا اتصال، ولا دفعة، ولا طابور محلي، ولا أي
 * قاعدة عمل تعمل خارج الخادم. ولا يحجب الشاشة — القراءة المعروضة سلفًا تبقى ظاهرة.
 */
export function OfflineBanner() {
  const [online, setOnline] = useState(isOnline);

  useEffect(() => {
    const update = () => setOnline(isOnline());
    window.addEventListener('online', update);
    window.addEventListener('offline', update);
    return () => {
      window.removeEventListener('online', update);
      window.removeEventListener('offline', update);
    };
  }, []);

  if (online) return null;
  return (
    <div role="status" className="border-b border-amber-200 bg-amber-50 px-3 py-2 text-center text-sm text-amber-900">
      لا يوجد اتصال بالإنترنت — لا يمكن حفظ أي عملية حتى يعود الاتصال.
    </div>
  );
}
